import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

const TOUR_STORAGE_KEY = 'garaoke_tour_completed';

export const isTourCompleted = () => {
  return localStorage.getItem(TOUR_STORAGE_KEY) === 'true';
};

export const markTourCompleted = () => {
  localStorage.setItem(TOUR_STORAGE_KEY, 'true');
};

export const resetTourStatus = () => {
  localStorage.removeItem(TOUR_STORAGE_KEY);
};

export const startInteractiveTour = (force = false) => {
  if (!force && isTourCompleted()) {
    return null;
  }

  // Inyectar estilos temáticos y correcciones visuales de alto contraste
  const styleId = 'garaoke-driver-theme';
  let styleEl = document.getElementById(styleId);
  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = styleId;
    document.head.appendChild(styleEl);
  }

  styleEl.innerHTML = `
    /* Overlay SVG: NO aplicar backdrop-filter al overlay completo porque empañaría el componente recortado */
    .driver-overlay {
      pointer-events: none !important;
    }
    .driver-overlay path {
      transition: fill 0.35s ease !important;
    }

    /* Popover de Garaoke */
    .driver-popover.garaoke-tour-popover {
      background: #111424 !important;
      border: 1px solid #00f0ff !important;
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.9), 0 0 30px rgba(0, 240, 255, 0.3) !important;
      color: #ffffff !important;
      border-radius: 16px !important;
      padding: 20px 22px !important;
      max-width: 390px !important;
      font-family: inherit !important;
      z-index: 1000000005 !important;
    }

    /* Popover inicial de bienvenida centrado */
    .driver-popover.garaoke-tour-welcome-popover {
      max-width: 450px !important;
      border: 2px solid rgba(168, 85, 247, 0.8) !important;
      box-shadow: 0 25px 70px rgba(0, 0, 0, 0.95), 0 0 45px rgba(168, 85, 247, 0.4) !important;
      text-align: center !important;
    }
    .driver-popover.garaoke-tour-welcome-popover .driver-popover-title {
      font-size: 1.35rem !important;
      color: #fff !important;
      background: linear-gradient(135deg, #00f0ff 0%, #c084fc 50%, #ff2d9b 100%) !important;
      -webkit-background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
      margin-bottom: 12px !important;
    }
    .driver-popover.garaoke-tour-welcome-popover .driver-popover-footer {
      justify-content: center !important;
    }

    .driver-popover.garaoke-tour-popover .driver-popover-title {
      font-size: 1.15rem !important;
      font-weight: 800 !important;
      color: #00f0ff !important;
      text-shadow: 0 0 14px rgba(0, 240, 255, 0.6) !important;
      margin-bottom: 10px !important;
      letter-spacing: 0.3px !important;
    }

    .driver-popover.garaoke-tour-popover .driver-popover-description {
      font-size: 0.92rem !important;
      color: rgba(255, 255, 255, 0.92) !important;
      line-height: 1.6 !important;
      margin-bottom: 18px !important;
    }

    .driver-popover.garaoke-tour-popover .driver-popover-close-btn {
      color: rgba(255, 255, 255, 0.6) !important;
      font-size: 1.3rem !important;
      transition: all 0.2s ease !important;
      top: 12px !important;
      right: 12px !important;
    }
    .driver-popover.garaoke-tour-popover .driver-popover-close-btn:hover {
      color: #ff0055 !important;
      transform: scale(1.2) rotate(90deg) !important;
    }

    .driver-popover.garaoke-tour-popover .driver-popover-footer {
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      gap: 10px !important;
      margin-top: 14px !important;
      padding-top: 14px !important;
      border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
    }

    .driver-popover.garaoke-tour-popover .driver-popover-progress-text {
      font-size: 0.8rem !important;
      color: #00f0ff !important;
      font-weight: 700 !important;
      letter-spacing: 0.5px !important;
    }

    .driver-popover.garaoke-tour-popover .driver-popover-navigation-btns {
      display: flex !important;
      gap: 8px !important;
    }

    .driver-popover.garaoke-tour-popover button.driver-popover-prev-btn {
      background: rgba(255, 255, 255, 0.08) !important;
      color: rgba(255, 255, 255, 0.85) !important;
      border: 1px solid rgba(255, 255, 255, 0.2) !important;
      border-radius: 9px !important;
      padding: 7px 15px !important;
      font-size: 0.82rem !important;
      font-weight: 600 !important;
      text-shadow: none !important;
      cursor: pointer !important;
      transition: all 0.2s ease !important;
    }
    .driver-popover.garaoke-tour-popover button.driver-popover-prev-btn:hover {
      background: rgba(255, 255, 255, 0.18) !important;
      color: #fff !important;
      border-color: rgba(255, 255, 255, 0.4) !important;
    }

    .driver-popover.garaoke-tour-popover button.driver-popover-next-btn {
      background: linear-gradient(135deg, #00f0ff 0%, #7000ff 100%) !important;
      color: #080a14 !important;
      border: none !important;
      border-radius: 9px !important;
      padding: 7px 18px !important;
      font-size: 0.85rem !important;
      font-weight: 800 !important;
      text-shadow: none !important;
      box-shadow: 0 0 15px rgba(0, 240, 255, 0.5) !important;
      cursor: pointer !important;
      transition: all 0.2s ease !important;
    }
    .driver-popover.garaoke-tour-popover button.driver-popover-next-btn:hover {
      opacity: 0.95 !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 0 25px rgba(0, 240, 255, 0.8) !important;
    }

    /* FLECHAS DEL POPOVER DE ALTO CONTRASTE CON GLOW NEÓN CYAN */
    .driver-popover.garaoke-tour-popover .driver-popover-arrow {
      border-width: 9px !important;
    }
    .driver-popover.garaoke-tour-popover .driver-popover-arrow-side-left {
      border-left-color: #00f0ff !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      filter: drop-shadow(3px 0 8px #00f0ff) !important;
    }
    .driver-popover.garaoke-tour-popover .driver-popover-arrow-side-right {
      border-right-color: #00f0ff !important;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      filter: drop-shadow(-3px 0 8px #00f0ff) !important;
    }
    .driver-popover.garaoke-tour-popover .driver-popover-arrow-side-top {
      border-top-color: #00f0ff !important;
      border-bottom-color: transparent !important;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      filter: drop-shadow(0 3px 8px #00f0ff) !important;
    }
    .driver-popover.garaoke-tour-popover .driver-popover-arrow-side-bottom {
      border-bottom-color: #00f0ff !important;
      border-top-color: transparent !important;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      filter: drop-shadow(0 -3px 8px #00f0ff) !important;
    }

    /* RESALTADO NÍTIDO Y BRILLANTE PARA EL COMPONENTE ACTIVO */
    @keyframes pulseNeonSpotlight {
      0% {
        box-shadow: 0 0 0 3px #00f0ff, 0 0 25px rgba(0, 240, 255, 0.7), 0 0 50px rgba(0, 240, 255, 0.3) !important;
      }
      100% {
        box-shadow: 0 0 0 4px #38bdf8, 0 0 40px rgba(56, 189, 248, 0.9), 0 0 80px rgba(0, 240, 255, 0.5) !important;
      }
    }

    .driver-active-element {
      position: relative !important;
      z-index: 1000000000 !important;
      border-radius: 12px !important;
      animation: pulseNeonSpotlight 1.6s infinite alternate ease-in-out !important;
      pointer-events: auto !important;
    }
  `;

  const driverObj = driver({
    showProgress: true,
    animate: true,
    allowClose: true,
    overlayColor: 'rgba(4, 5, 14, 0.84)',
    stagePadding: 8,
    stageRadius: 12,
    popoverClass: 'garaoke-tour-popover',
    nextBtnText: 'Siguiente →',
    prevBtnText: '← Anterior',
    doneBtnText: '¡Comenzar a Cantar!',
    progressText: '{{current}} de {{total}}',
    onHighlightStarted: (element, step, { state }) => {
      const isInitial = state.activeIndex === 0;
      const overlayPath = document.querySelector('.driver-overlay path');
      if (overlayPath) {
        // En el paso inicial difuminar muy poco el fondo para que el karaoke completo se aprecie detrás
        // En los pasos siguientes, oscurecer bien el fondo para hacer foco en el componente señalado
        overlayPath.style.fill = isInitial ? 'rgba(4, 5, 14, 0.32)' : 'rgba(4, 5, 14, 0.86)';
      }
    },
    onDestroyStarted: () => {
      markTourCompleted();
      driverObj.destroy();
    },
    steps: [
      {
        // Paso 0: Cartel inicial de bienvenida centrado con difuminado suave del fondo
        popover: {
          title: '🎉 ¡Bienvenido al Paseo Guiado de Garaoke!',
          description: 'Estás en la <strong>Consola Central de Karaoke</strong>.<br/><br/>A continuación te mostraremos rápidamente cómo buscar canciones, organizar la fila de cantantes, animar la fiesta con efectos y proyectar la letra en la TV para tu público.<br/><br/>¿Listo para comenzar?',
          popoverClass: 'garaoke-tour-popover garaoke-tour-welcome-popover',
          side: 'center',
          align: 'center'
        }
      },
      {
        // Paso 1: Buscador de Karaoke
        element: '#tour-search-bar',
        popover: {
          title: '🔍 1. Buscador de Canciones',
          description: 'Escribe el nombre de la canción o cantante para buscar videos de karaoke en tiempo real. Puedes reproducir de inmediato o enviar el tema a la cola de espera de la playlist.',
          side: 'bottom',
          align: 'start'
        }
      },
      {
        // Paso 2: Playlist
        element: '#tour-playlist-card',
        popover: {
          title: '📋 2. Cola de Espera (Playlist)',
          description: 'Aquí ves la fila de cantantes. Puedes <strong>arrastrar y soltar</strong> las canciones hacia arriba o hacia abajo para cambiar los turnos al vuelo sin interrumpir el espectáculo.',
          side: 'right',
          align: 'start'
        }
      },
      {
        // Paso 3: Intros y transiciones
        element: '#tour-intros-transitions',
        popover: {
          title: '🎬 3. Cortinas y Transiciones',
          description: 'Selecciona las animaciones y cortinas musicales que se reproducirán automáticamente entre cada turno de karaoke, evitando baches de silencio entre cantantes.',
          side: 'top',
          align: 'start'
        }
      },
      {
        // Paso 4: Efectos de sonido
        element: '#tour-sound-effects',
        popover: {
          title: '👏 4. Efectos de Sonido en Vivo',
          description: '¡Dale euforia al show! Lanza aplausos, ovaciones, risas o abucheos con un solo clic. Puedes regular su volumen independiente de 0% a 200%.',
          side: 'left',
          align: 'center'
        }
      },
      {
        // Paso 5: Modo proyector / TV
        element: '#tour-projector-btn',
        popover: {
          title: '📺 5. Modo Pantalla TV / Proyector',
          description: 'Abre la ventana de reproducción independiente para arrastrarla a tu televisor o proyector. Tus invitados verán el video y la letra en pantalla completa mientras tú controlas todo aquí.',
          side: 'bottom',
          align: 'end'
        }
      },
      {
        // Paso 6: Centro de ayuda
        element: '#tour-help-menu',
        popover: {
          title: '❓ 6. Centro de Ayuda Siempre Disponible',
          description: 'Si en cualquier momento quieres volver a repasar este recorrido, consultar el manual de usuario (PDF), la guía de conexión a pantalla extendida o ver tutoriales de uso, abre este menú de ayuda.',
          side: 'bottom',
          align: 'end'
        }
      }
    ]
  });

  driverObj.drive();
  return driverObj;
};
